<app-layout></app-layout>
<ngx-spinner
    bdColor="rgba(0, 0, 0, 0.8)"
    template="<img src='../assets/flight-loader.gif' style='width:200px; height:200px;' />"
>
</ngx-spinner>